"use client"

import { Tooltip } from "@/components"
import { Text } from "@/elements"
import { InformationCircleIcon } from "@heroicons/react/24/outline"
import { FC } from "react"

interface Props {}

export const HowCreditsWork: FC<Props> = props => {
  return (
    <Tooltip
      contentProps={{
        align: "end",
        side: "bottom",
      }}
      trigger={
        <div className="flex cursor-default flex-row items-center gap-1 rounded-sm bg-bg-2 px-2 py-1">
          <InformationCircleIcon className="size-[18px] stroke-fg-1" />
          <Text className="" variant="caption">
            How do credits work?
          </Text>
        </div>
      }
      text="Credits show the number of past projects you've completed in this role. Each completed project on your portfolio tagged in this role counts as one credit."
      textClassName="text-left"
      width={270}
    />
  )
}
